import moment from 'moment';
import {TimeListItem} from '../../types';

export const sortTimesListItems = (itemA: TimeListItem, itemB: TimeListItem): number => {
  const timeA = moment(itemA.time).set({
    day: moment().get('day'),
  });

  const timeB = moment(itemB.time).set({
    day: moment().get('day'),
  });

  return timeA.isBefore(timeB) ? -1 : 1;
};
